/*
 * @Description: 广告系列管理
 */
<template>
    <div id="series-detail">
        <!-- 顶部header模块 -->
        <header slot="header" class="c-body-header">
            <div class="header-row">
                <div class="header-row-left">
                    <!-- <router-link :to="{path: '/newPromition', query: {type: 'series', action: 'add'}}"  class="header-button-primary"
                        >新建广告系列</router-link
                    > -->
                </div>
                <div class="header-row-right">
                    <!-- 预设日期按钮 -->
                    <c-date-picker
                        :startDay.sync="tableParams.startDay"
                        :endDay.sync="tableParams.endDay"
                        @change="getList"
                    />
                </div>
            </div>
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 搜索 -->
                    <Input
                        v-if="!selectedCount"
                        v-model="tableParams.keyword"
                        placeholder="搜索广告组名称/ID"
                        class="header-search"
                        icon="android-search"
                        @on-keydown.enter="getList(true)"
                        @on-click="getList(true)"
                    />
                    <Input
                        v-if="!selectedCount"
                        v-model="tableParams.publisherName"
                        placeholder="搜索账号名(邮箱)"
                        class="header-search"
                        icon="android-search"
                        @on-keydown.enter="getList(true)"
                        @on-click="getList(true)"
                    />
                    <Button @click="onClickDown" type="primary">下载</Button>


                    <!-- 批量操作 -->
                    <!-- <div v-else class="edit-box">
                        <div class="edit">
                            <span>已选择{{ selectedCount }}项</span>
                            <span class="close-btn" @click.stop="onSelectedAll(false)">
                                <Icon type="close" />
                            </span>
                        </div>
                        <Dropdown @on-click="onChangeBatchType" trigger="click">
                            <button class="header-button-ghost">
                                <span class="header-button-ghost-span">
                                    <span>批量编辑</span>
                                </span>
                                <i class="icon header-button-ghost-down"></i>
                            </button>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in BatchType" :name="item" :key="index">{{
                                    item
                                }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div> -->
                </div>
                <div class="header-row-right">
                    <!-- 状态筛选 -->
                    <Dropdown trigger="click" @on-click="(val) => changeStatus('status', val)">
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span">状态：{{ statusValue[tableParams.status] }}</span>
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-for="(value, index) in statusList"
                                :name="value.name"
                                :selected="value.name == tableParams.status"
                                :key="index"
                                >{{ value.value }}</DropdownItem
                            >
                        </DropdownMenu>
                    </Dropdown>
                    <!-- 投放状态筛选 -->
                    <Dropdown trigger="click" @on-click="(val) => changeStatus('dropDownStatus', val)">
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span"
                                >投放状态：{{ dropdownStatusValue[tableParams.dropDownStatus] }}</span
                            >
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-for="(value, index) in dropdownStatusList"
                                :name="value.name"
                                :selected="value.name == tableParams.dropDownStatus"
                                :key="index"
                                >{{ value.value }}</DropdownItem
                            >
                        </DropdownMenu>
                    </Dropdown>
                    <!-- AUTO状态筛选 -->
                    <!-- <Dropdown
                        v-if="userData.autoType == 1"
                        trigger="click"
                        @on-click="(val) => changeStatus('offerBundleStatus', val)"
                    >
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span"
                                >AUTO状态：{{ offerBundleStatusValue[tableParams.offerBundleStatus] }}</span
                            >
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-for="(value, index) in offerBundleStatusList"
                                :name="value.name"
                                :selected="value.name == tableParams.offerBundleStatus"
                                :key="index"
                                >{{ value.value }}</DropdownItem
                            >
                        </DropdownMenu>
                    </Dropdown> -->
                    <!-- 自定义列 -->
                    <!-- <quota @onIndicatorList="onIndicatorList"></quota>
                    <button class="header-button-ghost" @click="onClickDown">
                        <span class="header-button-ghost-span">下载</span>
                    </button> -->
                    <!-- 刷新 -->
                    <button
                        class="header-button-ghost refresh-btn"
                        @click="getList(false)"
                        title="刷新"
                        style="margin: 0"
                    >
                        <i class="icon icon-refresh"></i>
                    </button>
                </div>
            </div>
        </header>
        <!-- 顶部header模块 -->
        <!-- 主体section模块 -->
        <section slot="section" class="c-body-section">
            <!-- 表格 -->
            <!-- <cTable
                @itemChange="confirmItem"
                type="series"
                :summary="summary"
                :tableDefaultIndicator="tableDefaultIndicator"
                :originList="originData"
                :tableParams.sync="tableParams"
                :indicatorList="indicatorList"
                @check="saveSelected"
                @change="getList(false)"
                @editBudget="showEditBudget"
                @copySeries="copySeries"
            /> -->


            <el-table
                :data="originData"
                style="width: 100%;border:1px solid #EBEEF5"
                @select="handleSelectionChange"
                ref="multipleTable"
                class="el-table_css"
            >   
                <el-table-column fixed type="selection"  width="70"> </el-table-column>
                <el-table-column fixed prop="code" label="ID" width="70"> </el-table-column>
                <el-table-column fixed prop="name" label="广告系列名称" width="200">
                    <template slot-scope="scope" >
                            <span v-if="scope.$index == 0">{{scope.row.name}}</span>
                            <span v-else class="Css_tableName" @click="Fun_tableName(scope.row)">{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed prop="email" label="账号名（邮箱）" width="150"> </el-table-column>
                <el-table-column  prop="install" label="状态" width="80">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <el-switch
                                @change="TableGZState(scope.row)"
                                v-model="scope.row.status"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                :active-value="1"
                                :inactive-value="0">
                            </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="dropDownStatus" label="投放状态" width="120">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <span v-if="scope.row.dropDownStatus" style="color:green">已投放</span>
                            <span v-else style="color:red">未投放</span>
                    </template>
                </el-table-column>
                <el-table-column prop="industry" label="行业" width="120"> </el-table-column>
                <el-table-column prop="bid" label="竞价请求量" width="120"> </el-table-column>
                <el-table-column prop="imp" label="展现量" width="120"> </el-table-column>
                <el-table-column prop="click" label="点击量" width="120"> </el-table-column>
                <el-table-column prop="ctr" label="CTR" width="120"> </el-table-column>
                <el-table-column prop="cpa" label="CPA" width="120"> </el-table-column>
                <el-table-column prop="cpc" label="CPC" width="120"> </el-table-column>
                <el-table-column prop="cpm" label="CPM" width="120"> </el-table-column>
                <el-table-column prop="calculateImp" label="补/扣量后的clickimp数" width="140"> </el-table-column>
                <el-table-column prop="calculateClick" label="补/扣量后的click数" width="150"> </el-table-column>
                <el-table-column prop="calculateSpends" label="补/扣量后的花费数" width="140"> </el-table-column>
                <el-table-column prop="calculateCpc" label="补/扣量后的cpc" width="140"> </el-table-column>
                <el-table-column prop="calculateCpm" label="补/扣量后的cpm" width="140"> </el-table-column>

                <!-- <el-table-column prop="install" label="安装量" width="120"> </el-table-column>
                <el-table-column prop="installRate" label="安装率" width="100"> </el-table-column> -->
                <el-table-column prop="deal" label="转化量" width="120"> </el-table-column>
                <el-table-column prop="dealRate" label="转化率" width="100"> </el-table-column>
                <el-table-column prop="ecpm" label="eCPM" width="120"> </el-table-column>
                <el-table-column prop="amount" label="收益" width="120"> </el-table-column>

                <el-table-column
                    fixed="right"
                    label="操作"
                    width="120">
                <template slot-scope="scope"  v-if="scope.$index != 0">
                    <el-button @click.native.prevent="onchangeItem('edit',scope.row.code,scope.row.publisherId)" type="text" size="small"> 编辑 </el-button>
                </template>

                </el-table-column>
        </el-table>
        </section>
        <!-- 预算 -->
        <cBudgetSimple :show.sync="show" @save="confirmBudget"></cBudgetSimple>
        <!-- 日期 -->
        <Modal v-model="show.date" width="500" class="c-modal" @on-ok="submitDate">
            <p slot="header" class="modal-header">修改日期</p>
            <div class="modal-detail">
                <div class="modal-row">
                    <span class="modal-row-label">日期：</span>
                    <!-- 日期选择 -->
                    <date-picker
                        :value="date"
                        class="modal-row-input manage-input-box"
                        type="daterange"
                        placement="bottom-end"
                        placeholder="选择日期，默认不限"
                        style="font-size: 0.1rem"
                        @on-change="(arr) => (date = [...arr])"
                    />
                </div>
            </div>
        </Modal>
        <!-- 日期 -->
        <footer slot="footer" class="c-body-footer">
            <!-- 分页器 -->
            <c-page
                :table-params.sync="tableParams"
                :page-bean.sync="pageBean"
                class="foot-row"
                @on-change="getList(false)"
                @on-page-size-change="getList(true)"
            />
        </footer>
    </div>
</template>
<script>
import mixins from '@/mixins/index.js';
import cBody from '@/components/commons/cBody.vue';
import cDatePicker from '@/components/commons/cDatePicker.vue';
import quota from '@/components/commons/quota.vue';
import cPage from '@/components/commons/cPage.vue';
import cTable from '@/components/commons/manageTable.vue';
import cBudgetSimple from '@/components/commons/cBudgetSimple.vue';
import cBid from '@/components/commons/cBid.vue';
import tablelist from '@/server/tablelist.js';
import { mapState } from 'vuex';
export default {
    name: 'managementSeries',
    mixins: [mixins],
    components: {
        cTable,
        cBudgetSimple,
        cBid,
        cBody,
        cDatePicker,
        quota,
        cPage,
    },
    props: {
        tagSeries: {
            type: Number,
        },
    },
    data() {
        return {
            //编辑列表
            editList: [],
            //批量修改预算
            date: [], //批量修改时期
            //显示控制器
            show: {
                date: false,
                dailyBudget: false,
            },
            //推广列表数据
            originData: [],
            //分页对象
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 1,
            },
            //获取推广列表的参数
            tableParams: {
                page: 1,
                pageSize: 10,
                startDay: this.mixinGetDate('today'),
                endDay: this.mixinGetDate('today'),
                status: '',
                dropDownStatus: '',
                offerBundleStatus: '',
                keyword: '',
                orderName: 'code',
                orderType: 'desc',
                publisherName:"",
                dimension:'campaign_series',
            },
            //汇总
            summary: {},
            //批量操作类型数组
            BatchType: ['开启', '停止', '归档', '预算', '日期'],
            //指标列表
            indicatorList: tablelist['series'],
            tableDefaultIndicator: [
                {
                    code: 'id',
                    id: 0,
                    selected: true,
                    isDefault: true,
                    name: 'ID',
                    sortor: true,
                },
                {
                    code: 'series',
                    id: 1,
                    selected: true,
                    isDefault: true,
                    name: '广告系列名称',
                    sortor: false,
                },
                {
                    code: 'dropDownStatus',
                    id: 100,
                    selected: true,
                    isDefault: true,
                    name: '投放状态',
                    sortor: false,
                },
            ],

            tableradio:[],
            echoList:[],
        };
    },
    watch: {
        tagSeries: {
            handler(value) {
                if (!value) {
                    this.originData.map((item) => (item.selected = false));
                }
            },
            immediate: true,
        },
        'tableParams.status'(value) {
            if (value == '3') {
                this.BatchType = ['预算', '日期', '还原'];
            } else {
                this.BatchType = ['开启', '停止', '归档', '预算', '日期'];
            }
        },
    },
    computed: {
        ...mapState({
            userData: (state) => state.userData,
            dropdownStatusValue: (state) => state.promotionManagement.dropdownStatusValue,
            offerBundleStatusValue: (state) => state.promotionManagement.offerBundleStatusValue,
            dropdownStatusList: (state) => state.promotionManagement.dropdownStatusList,
            offerBundleStatusList: (state) => state.promotionManagement.offerBundleStatusList,
            statusText: (state) => state.promotionManagement.statusText,
            statusColor: (state) => state.promotionManagement.statusColor,


            statusValue: (state) => state.promotionManagement.adminstatusValue,
            statusList: (state) => state.promotionManagement.adminstatusList,
        }),
        //已选择
        selectedCount() {
            return this.originData.filter((item) => item.selected).length;
        },
        //已选择数组
        selectedList() {
            return this.originData.filter((item) => item.selected);
        },
    },
    mounted() {
        // if (this.$store.state.manageData.series) {
        //     if (this.$store.state.manageData.series.tableParams) {
        //         this.tableParams = { ...this.$store.state.manageData.series.tableParams };
        //     }
        //     if (this.$store.state.manageData.series.indicatorList) {
        //         this.indicatorList = { ...this.$store.state.manageData.series.indicatorList };
        //     }
        // }
        // this.$store.dispatch('mangeData', { name: 'clear-group' });
        // this.$store.dispatch('mangeData', { name: 'clear-ad' });
        this.getList(false, true);
    },
    methods: {
        // 选择关联产品：打勾或取消
        handleSelectionChange(selecteds, row) {
                if (!this.echoList.includes(row.code)) {
                    // 回显数据里没有本条，把这条加进来(选中)
                    this.echoList.push(row.code);
                } else {
                    // 回显数据里有本条，把这条删除(取消选中)
                    this.echoList.forEach((id, index) => {
                    if (id === row.code) {
                        this.echoList.splice(index, 1);
                    }
                });
        }
        sessionStorage.setItem('Selection_series',JSON.stringify(this.echoList));
        this.$emit('screenNum','Selection_series',this.echoList.length)
        },
        //清空所选项
        Fun_Selection_cleos(){
            this.echoList = []
            this.$refs.multipleTable.clearSelection()
        },
        Fun_tableName(item){
            this.echoList = []
            this.$refs.multipleTable.clearSelection()
            this.echoList.push(item.code)
            sessionStorage.setItem('Selection_series',JSON.stringify(this.echoList));
            // this.$refs.multipleTable.toggleRowSelection(item, true);

            this.$emit('onClickTab',{name:'adv-group'})
            this.$emit('screenNum','Selection_series',this.echoList.length)
        },

        TableGZState(item){
            console.log('item',item)
            this.confirmItem(item)
        },  
        /**
         * @description 表格item操作
         * @param item
         */
         onchangeItem(action, id,publisherId) {
            let type = 'series'
            console.log(action, id)
            window.open(`${location.origin}/#/newPromition?type=${type}&action=${action}&id=${id}&publisherId=${publisherId}`,'_self');
        },


        /**
         * @desc: 全选
         * @param {Boolean} bool 全选的状态
         */
        onSelectedAll(bool) {
            this.originData.forEach((item) => (item.selected = bool));
            this.saveSelected();
        },
        /**
         * @desc: 复制自动广告系列
         * @param {String} seriesId:复制的广告系列id
         */
        async copySeries(seriesId) {
            const { $axios, $port, getList } = this;
            const res = await $axios.get($port.series.copySeries, { params: { seriesId } });
            if (res.status == 200) getList(false, false);

            $axios.commonCallback(res, '复制成功');
        },
        /**
         * @desc 报表下载
         */
        onClickDown() {
            const params = Object.assign({}, this.tableParams);
            params.rd = new Date().getTime();
            let queryString = `${this.$port.globalReport.downloadAdmin}?`;
            for (let i in params) {
                queryString += `${i}=${params[i]}&`;
            }
            
            window.location.href = queryString;
        },
        /**
         * @desc: 获取指标列表更新
         */
        onIndicatorList(data) {
            this.$store.dispatch('mangeData', {
                name: 'series',
                value: { indicatorList: this.deepClone(data) },
            });
            this.indicatorList = this.deepClone(data);
        },
        /**
         * @desc: 保存列表数据项选择
         */
        saveSelected() {
            this.$store.dispatch('mangeData', {
                name: 'series',
                value: {
                    selectCount: this.originData.filter((item) => item.selected).length,
                    selectArray: this.originData.filter((item) => item.selected),
                },
            });
        },
        /**
         * @desc: 归档还原
         * @param {Object} item: 推广对象
         */
        async restoreCampaign(item) {
            const res = await this.$axios.get(this.$port.seriesTable.batchUpdate, { params: { id: item.id } });
            this.$axios.commonCallback(res, '还原成功');
            this.getList();
        },
        /**
         * @desc: 确认修改单项参数
         */
        async confirmItem(item) {
            const params = [
                {
                    id: item.code,
                    status: item.status,
                },
            ];
            const res = await this.$axios.post(this.$port.seriesTable.batchUpdate, params);
            this.afterSubmit(res);
        },
        /**
         * @desc: 获取推广数据
         * @param {Boolean} isInit: 是否初始化页数
         * @param {Boolean} isLoad: 是否是加载页面
         */
        async getList(isInit, isLoad) {
            console.log('isInit',isInit)
            if (isInit) this.tableParams.page = 1;
            //获取表格数据 -获取汇总数据
            let params = { ...this.tableParams };
            const resList = await this.$axios.get(this.$port.seriesTable.seriesList, { params });
            if (resList.data.pageBean) this.pageBean = resList.data.pageBean;
            if (resList.data.list) {
                this.originData = resList.data.list;

                this.echoList = sessionStorage.getItem('Selection_series') ? JSON.parse(sessionStorage.getItem('Selection_series')) : []
                this.$nextTick(() => {
                    this.originData.forEach(item => {
                        // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
                        // toggleRowSelection(item, true)：设置当前行数据为选中状态
                        if(this.echoList.length){
                            if (this.echoList.includes(item.code)) {
                                this.$refs.multipleTable.toggleRowSelection(item, true);
                            }
                        }
                    });
	            });




                // this.summary = resList.data.list[0];
                // //如果有选择记录
                // const selectArray = this.$store.state.manageData.series.selectArray;
                // this.originData = resList.data.list
                //     .filter((item, index) => index > 0)
                //     .map((item) => {
                //         item.selected = false;
                //         if (selectArray && selectArray.length > 0) {
                //             if (selectArray.some((ari) => ari.id === item.id)) item.selected = true;
                //         }
                //         return item;
                //     });
                // { "code": "4362", "name": "888_10.17-新广告位-JOB-BR4-5511960504675", "bid": "0", "imp": "0", "click": "0", "ctr": "0", "install": "0", "installRate": "0.00%", "deal": "0", "dealRate": "0.00%", "ecpm": "0.00", "amount": "0.00", "accountName": "xinfuzhi84881", "email": "xinfuzhi84881@163.com", "publisherId": "1009937", "status": 0, "dropDownStatus": 0 }
            }

            let value = {};
            if (isLoad) {
                value = {
                    selectCount: this.originData.filter((item) => item.selected).length,
                    selectArray: this.originData.filter((item) => item.selected),
                };
            } else {
                value = {
                    selectCount: 0,
                    selectArray: [],
                    tableParams: { ...this.tableParams },
                };
            }
            this.$store.dispatch('mangeData', {
                name: 'series',
                value,
            });
        },
        /**
         * @desc: 状态筛选
         * @param {String} name: 选择的状态名
         * @param {String} value: 选择的状态值
         */
        changeStatus(name, value) {
            this.$set(this.tableParams, name, value);
            this.getList(true);
        },
        /**
         * @desc: 显示预算编辑
         * @param {Object} item:
         */
        showEditBudget(item) {
            this.show.dailyBudget = true;
            this.editList = [item];
        },
        /**
         * @desc: 点击批量操作时
         * @param {Number} value: 批量操作索引
         */
        onChangeBatchType(value) {
            if (this.selectedCount < 1) {
                this.$Message.warning({
                    content: '请先选择要批量操作的推广',
                    duration: 1.5,
                });
            } else {
                if (value == '预算') {
                    this.show.dailyBudget = true;
                    this.editList = [...this.selectedList];
                } //打开预算
                if (value == '日期') this.show.date = true; //打开时期
                if (value == '开启') this.batchUpdate(1); //批量开启
                if (value == '停止') this.batchUpdate(0); //批量停止
                if (value == '还原') this.batchUpdate(0); //批量还原
                if (value == '归档') this.batchUpdate(3); //批量归档
            }
        },
        /**
         * @desc:批量更新状态
         * @param status:string or number 要更新的状态
         */
        async batchUpdate(status) {
            const campaignStatuss = this.originData
                .filter((item) => item.selected)
                .map((item) => ({
                    id: item.id,
                    status: status,
                }));
            const res = await this.$axios.post(this.$port.seriesTable.batchUpdate, campaignStatuss);
            if (res.status == 200) {
                this.getList();
                this.$Message.success({ content: '修改成功', duration: 2 });
            } else {
                this.$Message.error({ content: res.message, duration: 3 });
            }
        },
        /**
         * @desc: 确认预算
         */
        confirmBudget({ type, value }) {
            this.show.dailyBudget = false;
            this.submitBudget(
                this.editList.map((item) => ({
                    id: item.id,
                    dailyBudget: 0,
                    dailyClick: 0,
                    dailyImp: 0,
                    [type]: ~~value,
                }))
            );
        },
        /**
         * @desc: 提交修改日期
         */
        async submitDate() {
            let arr = [];
            this.selectedList.forEach((item, index) =>
                arr.push({
                    id: item.id,
                    startDay: this.date[0],
                    endDay: this.date[1],
                })
            );
            const params = arr;
            const res = await this.$axios.post(this.$port.seriesTable.batchUpdate, params);
            this.afterSubmit(res);
        },
        /**
         * @desc: 提交预算
         * @param {Object} params: 提交的参数
         */
        async submitBudget(params) {
            const res = await this.$axios.post(this.$port.seriesTable.batchUpdate, params);
            this.afterSubmit(res);
        },
        /**
         * @description 批量操作后回调
         * @param res:obj 请求回调对象
         */
        afterSubmit(res) {
            if (res.status == 200) {
                this.$Message.success({ content: '修改成功', duration: 1.5 });
                this.getList(false);
            } else {
                this.$Message.error({ content: '修改失败', duration: 1.5 });
            }
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently.scss';
@import 'src/style/cModal.scss';
.manage-input-box {
    .ivu-icon-ios-calendar-outline {
        &:before {
            content: '\F3F3' !important;
        }
    }
}
#series-detail {
    .header-search {
        width: 3rem !important;
    }
    #c-body .c-body-section .c-body-table .table-tr {
        .table-td-primary {
            min-width: 0.4rem;
        }
        .table-td-primary:nth-of-type(1) {
            padding-right: 0;
            padding-left: 0.2rem;
        }
        //展示删除创意按钮
    }
    .edit-box {
        justify-content: flex-end;
        display: flex;
        width: 2.5rem;
        position: relative;
        align-items: center;
        .edit {
            width: 2.5rem;
            height: 100%;
            display: flex;
            align-items: center;
            position: absolute;
            flex: 1;
            .close-btn {
                cursor: pointer;
                position: absolute;
                right: 1.2rem;
            }
        }
    }

    .flex-text-title {
        overflow: auto;
        text-overflow: initial;
        white-space: normal;
        max-width: none;
    }
}

.el-table_css{
    .el-table__header{.el-table-column--selection{.cell{opacity:0 !important;}}}
    .el-table__body{.el-table__row:nth-child(1){.el-table-column--selection{.cell{opacity:0 !important;}}}}
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    border-color: #23c52f;
    background-color:#23c52f,
}
.Css_tableName{
    cursor: pointer;
    &:hover{color:#23c52f}
}
</style>



// WEBPACK FOOTER //
// src/view/PromotionManagement/Series.vue